import {
  RichTextEditorToolbarSticky,
  useRichTextEditorContext,
} from '@/components/RichTextEditor';
import { Button } from '@simplywallst/ui-core/next';

type Props = {
  onSubmit: (contentHtml: string) => void;
  submitText: string;
};

export const AnnouncementModalEditorToolbar = ({
  onSubmit,
  submitText,
}: Props) => {
  const { editor } = useRichTextEditorContext();

  const text = editor?.getText() || '';
  return (
    <RichTextEditorToolbarSticky>
      <div className="grid items-center">
        <Button
          variant="secondary"
          size="large"
          isDisabled={text.length === 0}
          onClick={() => onSubmit(editor?.getHTML() ?? '')}
        >
          {submitText}
        </Button>
      </div>
    </RichTextEditorToolbarSticky>
  );
};
